import { sortBy, noop } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@blockcatio/tabby-library/lib/components/Spinner';
import PaymentListMessage from './PaymentListMessage';

import Payment from './Payment';

const PaymentList = ({
  payments,
  className,
  acceptPayment,
  cancelPayment,
  onPaymentRemove,
  heading,
  emptyText,
  recommendedGasPrice,
  notify,
  formatPaymentAmount,
  paymentsFetching,
}) => {
  const paymentRows = sortBy(payments || [], 'sentTimestamp')
    .map(payment => (
      <Payment
        payment={payment}
        key={payment.transactionHash}
        acceptPayment={acceptPayment}
        cancelPayment={cancelPayment}
        onPaymentRemove={onPaymentRemove}
        recommendedGasPrice={recommendedGasPrice}
        notify={notify}
        formatPaymentAmount={formatPaymentAmount}
      />
    ))
    .reverse();

  return (
    <div className={`payment-list${className ? ` ${className}` : ''}`}>
      <h2 className="section-header">{heading}</h2>

      {paymentsFetching && (
        <PaymentListMessage>
          Loading payments...
          <Spinner loading small message="Loading Payments..." />
        </PaymentListMessage>
      )}
      {paymentsFetching === false &&
        (!payments || payments.length === 0) && (
          <PaymentListMessage>{emptyText}</PaymentListMessage>
        )}
      {paymentsFetching === false &&
        payments &&
        payments.length > 0 && (
          <table>
            <thead>
              <tr>
                <th className="id">Payment ID</th>
                <th className="time">Time</th>
                <th className="to">To</th>
                <th className="from">From</th>
                <th className="type">Type</th>
                <th className="amount">Amount</th>
                <th className="status">Status</th>
                <th className="options">Options</th>
              </tr>
            </thead>
            <tbody>{paymentRows}</tbody>
          </table>
        )}
    </div>
  );
};

PaymentList.defaultProps = {
  className: '',
  payments: [],
  cancelPayment: () => Promise.resolve(''),
  acceptPayment: () => Promise.resolve(''),
  onPaymentRemove: noop,
  heading: 'Payment History',
  emptyText: 'Your payment history is empty.',
  recommendedGasPrice: 0,
  notify: noop,
  formatPaymentAmount: noop,
  paymentsFetching: false,
};

PaymentList.propTypes = {
  payments: PropTypes.arrayOf(Payment.propTypes.payment),
  className: PropTypes.string,
  acceptPayment: PropTypes.func,
  cancelPayment: PropTypes.func,
  onPaymentRemove: PropTypes.func,
  heading: PropTypes.string,
  emptyText: PropTypes.string,
  recommendedGasPrice: PropTypes.number,
  notify: PropTypes.func,
  formatPaymentAmount: PropTypes.func,
  paymentsFetching: PropTypes.bool,
};

PaymentList.displayName = 'PaymentList';

export default PaymentList;



// WEBPACK FOOTER //
// ./src/components/PaymentList.js